import { useQuery } from '@tanstack/react-query';
import { morgansClient } from '../../../lib/connect/clients';
/** Every publication in the lineage a Notice belongs to, oldest version first (SAD-466). */ export function useNoticePublications(noticeId) {
    return useQuery({
        queryKey: [
            'noticePublications',
            noticeId
        ],
        queryFn: async ()=>(await morgansClient.listNoticePublications({
                noticeId
            })).publications
    });
}
